import { FileAttachment } from "./fileAttachment.model";
import { TAT } from "./lab.model";

export class LabRequisition {
    id: string;
    organizationLevelId: string;
    labIntegrationType: number;
    emailEdd: string;
    reportTo: string;
    reportToCompanyName: string;
    reportToAddress1: string;
    reportToAddress2: string;
    reportToCity: string;
    reportToState: string;
    reportToZip: string;
    reportToPhoneNumber: string;
    reportToCellNumber: string;
    reportToEmail: string;
    invoiceTo: string;
    invoiceCompanyName: string;
    invoiceComments: string;
    invoiceAddress1: string;
    invoiceAddress2: string;
    invoicePhoneNumber: string;
    invoicePoNumber: string;
    invoiceEmail: string;
    invoicePaymentInfo: string;
    labName: string;
    labAccountNumber: string;
    labAddress1: string;
    labAddress2: string;
    labCity: string;
    labState: string;
    labZip: string;
    labPhoneNumber: string;
    labCellNumber: string;
    labEmail: string;
    tats: TAT[];
    sampleIds?: string[];
    requisitionStatus?: number;
    accountNumber?: string;
    tatId?: string | null;
    reportToComments?: string;
    paymentTerms?: string;
    labId: string;
    generalComments?: string;
    labRequisitionNumber: string;
    industryProcessInterferenceDescription: string;
    fileAttachmentIds?: string[];
    fileAttachments?: FileAttachment[];
    applyBlankCorrection: boolean;
    isAutogenerated?: boolean;
}
